// HELPERS
// export const MOTIVOS_NEGACION = 35
// export const ESTADOS = 31
// export const REQUISITOS =  34

// HELPERS PRODUCCION

export const MOTIVOS_NEGACION = 77 
export const ESTADOS = 74
export const REQUISITOS =  76
export const CARRERAS = 5;

// ESTADOS EN LOS QUE LA SOLICITUD YA ESTA CERRADA Y NO SE PUEDE MOVER DE PERIODO
export const ESTADOS_CERRADOS_PERIODO = ['Val_Ate', 'Val_Neg', 'Val_Can'];

// PERMITE MODIFICAR DATOS DE UNA SOLICITUD (COORDINADOR, FECHA EXAMEN, PERIODO)
export const esAdminValidaciones = (usuario) => !!usuario && (usuario.correo == 'validaciones@cuc.edu.co' || (usuario.perfil && usuario.perfil.codigo == 'Per_Adm'));
